import { render, staticRenderFns } from "./Registerv1.vue?vue&type=template&id=1900a6b7"
import script from "./Registerv1.vue?vue&type=script&lang=js"
export * from "./Registerv1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports